/* eslint-disable indent */
import {
  Paper,
  Select as MUISelect,
  TextField,
  Button as MUIButton
} from '@mui/material';
import styled, { css } from 'styled-components';

import { shade } from 'polished';

export const Container = styled.div`
  margin-bottom: 20px;

  .MuiAccordion-root,
  .MuiAccordion-rounded,
  .MuiAccordion-gutters {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 25px;
    box-shadow: none;
    border: none;
  }

  table .tableRowStyle {
    border-bottom: none;
    box-shadow: none;
    border-radius: 5px;
    padding: 0px;
    background-color: #eee;
  }

  table .tableCellStyle {
    padding: '10px';
  }

  .MuiAccordionSummary-expandIconWrapper {
    font-size: 20px;
  }
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1140px;
  margin: 0 40px;
  display: flex;
  flex-direction: column;
`;

export const Section = styled(Paper)`
  padding: 20px;
  width: 100%;
  margin-bottom: 10px;

  .situation {
    flex-wrap: nowrap;
    border: none;
  }

  .textAreaContainer {
    position: relative;
  }

  hr {
    opacity: 0.5;
    margin: 20px 0;
  }

  Link {
    a:visited {
      color: #111111;
    }
    &:hover {
      background: ${shade(0.2, '#222222')};
    }
  }
`;

export const SectionTitle = styled.h3`
  font-size: 16px;
  margin-bottom: 10px;
  margin-top: 10px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 100%;
`;

export const ExpandBtn = styled.button`
  border: none;
  background-color: transparent;
`;

export const ContentRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex: 1;
  gap: 10px;

  .green {
    background-color: #8ec97b;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  .descritionText {
    width: 100%;
    margin: 20px 0;
  }

  .descritionText input {
    height: 200px;
    width: 100%;
  }

  .textArea {
    width: 100%;
    padding: 20px;
    height: 120px !important;
    overflow: auto !important;
    padding-bottom: 20px !important;
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    font-weight: 400;
    line-height: 1.4375em;
    letter-spacing: 0.00938em;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.4);
    margin-top: 20px;
    margin-bottom: 10px;
    border-radius: 4px;
    border: 1px solid #bbb;
    resize: none;
  }

  .green {
    background-color: #8ec97b;
  }
`;

export const TextAreaTitle = styled.p`
  color: rgba(0, 0, 0, 0.4);
  background-color: #fff;
  padding: 0 5px;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 1.4375em;
  letter-spacing: 0.00938em;
  display: block;
  transform-origin: top left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(133% - 24 px);
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 1;
  pointer-events: none;
`;

export const FormButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

export const Title = styled.p`
  font-weight: bold;
`;

export const ExpandBtnNf = styled.button`
  border: none;
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8;
`;

export const IconButton = styled.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border: none;
  outline: none;
  border-radius: 50%;
  margin-right: 4;
`;

export const TrackingContainer = styled.div`
  position: relative;
  display: flex;
  gap: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const Line = styled.div`
  height: 2px;
  border: 2px dashed #000;
  width: 40px;
  min-width: 40px;
  margin-top: 52px;
`;
